/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('public.case.response', {
      url: '/:id/response',
      template: '<response></response>',
    });
}



// WEBPACK FOOTER //
// ./client/app/public/case/response/response.routes.js